module.exports = __webpack_public_path__ + "media/components/navbar/static/logo-656016877166bd8f11e1aae6b4144988.png";